import { inject } from 'aurelia-framework';
import { HttpClient, json } from 'aurelia-fetch-client';

@inject(HttpClient)
export class PlantService {
    constructor(http) {
        this.http = http;
        this.singular = 'plant';
        this.plural = 'plants';
        this.editor = PLATFORM.moduleName('pages/quote-setup/plants/editor/index');
    }

    async filter(loadOptions) {
        const response = await this.http.fetch(`plants/filter/${loadOptions}`);
        return await response.json();
    }

    async create(plant) {
        await this.http.fetch('plants', { method: 'POST', body: json(plant) });
    }

    async update(plant) {
        await this.http.fetch(`plants/${plant.id}`, { method: 'PUT', body: json(plant) });
    }

    async delete(id) {
        await this.http.fetch(`plants/${id}`, { method: 'DELETE' });
    }

    async getById(id) {
        const response = await this.http.fetch(`plants/${id}`);
        return await response.json();
    }

    async filterTopThree(query) {
        if (query == null || query.length === 0) return [];
        const response = await this.http.fetch(`plants/top-three/${query}`);
        return await response.json();
    }
}